module.exports = __webpack_public_path__ + "static/media/jp.6a8f4d54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/jp.svg
// module id = 282
// module chunks = 0